<template>
    <div v-if="!store.noticeHidden" role="status" class="notice">
        <span class="notice-tag"><span class="notice-dot" />{{ NOTICE.tag }}</span>
        <span class="notice-text">{{ NOTICE.text }}</span>
        <button aria-label="Dismiss" class="notice-x ob-press" @click="store.dismissNotice">×</button>
    </div>
</template>

<script lang="ts" setup>
    import { NOTICE } from '@/data/content'
    import { useLandingStore } from '@/stores/landing'

    const store = useLandingStore()
</script>

<style scoped>
    .notice {
        position: relative;
        z-index: 61;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-wrap: wrap;
        gap: 12px;
        padding: 10px 52px;
        background: var(--ob-warn);
        color: var(--ob-warn-ink);
    }
    .notice-tag {
        display: inline-flex;
        align-items: center;
        gap: 8px;
        font-size: 11px;
        font-weight: 800;
        letter-spacing: .12em;
        text-transform: uppercase;
        background: var(--ob-black-a16);
        padding: 4px 10px;
        border-radius: 5px;
    }
    .notice-dot { width: 6px; height: 6px; border-radius: 50%; background: var(--ob-warn-ink); }
    .notice-text { font-size: 14px; font-weight: 600; }
    .notice-x {
        position: absolute;
        right: 14px;
        top: 50%;
        transform: translateY(-50%);
        background: var(--ob-black-a16);
        border: none;
        width: 24px;
        height: 24px;
        border-radius: 50%;
        cursor: pointer;
        color: var(--ob-warn-ink);
        font-size: 15px;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    @media (max-width: 700px) {
        .notice { padding: 8px 40px 8px 14px; gap: 8px; justify-content: flex-start; }
        .notice-text { font-size: 12.5px; }
    }
</style>
